<template>
  <div
    v-if="pages > 0"
    class="pagination"
  >
    <div
      class="pagination__btn pagination__arrow-left"
      @click="onPrev"
    >
      <svg width="8" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 12L6.91958 6.57372C6.96282 6.53408 6.96282 6.46592 6.91958 6.42628L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
    </div>
    <div
      v-for="(placeholder, index) of placeholders"
      :key="index"
      v-text="placeholder"
      class="pagination__btn"
      :class="getBtnClasses(placeholder)"
      @click="onChange(placeholder)"
    />
    <div
      class="pagination__btn pagination__arrow-right"
      @click="onNext"
    >
      <svg width="8" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 12L6.91958 6.57372C6.96282 6.53408 6.96282 6.46592 6.91958 6.42628L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppPagination',
  props: {
    /* CurrentPage */
    modelValue: {
      type: Number,
      default: 0
    },
    totalRows: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      currentPage: this.modelValue
    }
  },
  computed: {
    pages () {
      return Math.ceil(this.totalRows / this.perPage)
    },
    placeholders () {
      const result = []

      if (this.pages < 8) {
        for (let i = 0; i < this.pages; i++) {
          result.push(i + 1)
        }
      } else {
        if (this.currentPage < 5) {
          for (let i = 0; i < 5; i++) {
            result.push(i + 1)
          }

          result.push('...')
          result.push(this.pages)
        } else if (this.pages - this.currentPage < 4) {
          result.push(1)
          result.push('...')
          for (let i = this.pages - 5; i < this.pages; i++) {
            result.push(i + 1)
          }
        } else {
          result.push(1)
          result.push('...')
          result.push(this.currentPage - 1)
          result.push(this.currentPage)
          result.push(this.currentPage + 1)
          result.push('...')
          result.push(this.pages)
        }
      }

      return result
    }
  },
  watch: {
    modelValue (newVal) {
      this.currentPage = newVal
    }
  },
  methods: {
    getBtnClasses (placeholder) {
      return {
        pagination__btn_active: this.currentPage === placeholder,
        pagination__btn_empty: placeholder === '...'
      }
    },
    onChange (num) {
      this.currentPage = num
      this.$emit('update:modelValue', num)
    },
    onPrev () {
      if (this.currentPage === 1) { return }
      this.onChange(this.currentPage - 1)
    },
    onNext () {
      if (this.currentPage === this.pages) { return }
      this.onChange(this.currentPage + 1)
    }
  }
}
</script>

<style lang="scss" scoped>
$brand-color:                 #FF7A00 !default;

.pagination {
  display: inline-flex;
  background: #242428;
  border-radius: 12px;
  user-select: none;

  &__btn {
    padding: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.50);

    &_active {
      color: $brand-color;
    }

    &_empty {
      pointer-events: none;
    }
  }

  &__arrow-left,
  &__arrow-right{
    color: $brand-color;
  }

  &__arrow-left {
    transform: scale(-1, 1);
  }
}
</style>
